// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"dbad24f8","197":"769803e1","242":"fc43d394","706":"df621adf"}[chunkId] + ".chunk.css";
};